// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .ion-activatable {
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-form-fields/src/lib/date-picker/date-picker.component.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;AAAJ","sourcesContent":["::ng-deep {\n  .ion-activatable {\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
